module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-panel-container"
  }, [_c('docs-sidebar-container', {
    ref: "docsSidebar"
  }), _vm._v(" "), _c('common-panel-view', {
    attrs: {
      "is-authorized": _vm.isAuthorized,
      "profile-name": _vm.profileName,
      "doc-name": _vm.docName
    },
    on: {
      "login": function($event) {
        _vm.$emit('login')
      },
      "logout": function($event) {
        _vm.$emit('logout')
      },
      "open-menu": _vm.openMenu,
      "rename": _vm.rename
    }
  }), _vm._v(" "), _c('doc-name-dialog', {
    ref: "dialog",
    on: {
      "confirm": _vm.performRename
    },
    model: {
      value: (_vm.currentDocName),
      callback: function($$v) {
        _vm.currentDocName = $$v
      },
      expression: "currentDocName"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a8816ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommonPanelContainer.vue
// module id = 999
// module chunks = 1